module.exports = __webpack_public_path__ + "img/116.abfc46df.png";